module.exports = __webpack_public_path__ + "media/images/icons/outlined/carry-out-2ffde22af3a7685416de43e82455d41d.svg";